import styled from 'styled-components'
import ContentWrapper from './ContentWrapper'
import Title from './ContentTitle'
import Description from './ContentDescription'
import Submit from './Submit'

import warningIcon from '../assets/warning.svg'

const WarningIcon = styled.img`
    width: 44px;
    margin: 36px 0 33px;
`

WarningIcon.displayName = 'WarningIcon'

type Props = {
    message: string
    tryAgain: () => void,
}

const Error = ({ message, tryAgain }: Props) => {
    const getTitle = () => {
        if (message === 'filetype') {
            return 'File type not allowed'
        }

        if (message === 'filesize') {
            return 'File size is more than 10Mb'
        }

        return 'Unknown server error'
    }

    return <ContentWrapper>
        <WarningIcon src={warningIcon} alt='warning' />
        <Title>{getTitle()}</Title>
        <Description>Upload documents of up to 25 MB in .pdf format</Description>
        <Submit style={{width: '124px'}} onClick={()=>tryAgain()}>Try again</Submit>
    </ContentWrapper>
}

export default Error